import React from 'react';

type InputProps = {
  totalScore?: number;
};

export const AccountScoreBadge = ({ totalScore }: InputProps) => {
  if (typeof totalScore === 'undefined') {
    return null;
  }

  let tierStyle = 'yellow';
  let color = '';
  if (totalScore >= 5) {
    tierStyle = 'darkGreen';
    color = 'white';
  } else if (totalScore < 0) {
    tierStyle = 'red';
    color = 'white';
  }

  return (
    <div
      className={`
        u-borderRadius-15
        u-background-${tierStyle}
        typo-bold
        u-padding-y-xs
        u-padding-x-sm
        ${color ? `u-color-${color}` : ''}
      `}
    >
      {totalScore}
    </div>
  );
};
